import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ICmsAbstractButtonComponent, TButtonStyles } from '../icms-abstract-button.component';

@Component({
    standalone: false,
    selector: 'button[iCmsButtonStyle], a[iCmsButtonStyle]',
    templateUrl: './icms-button-style.html',
    styleUrls: ['./icms-button-style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ICmsButtonStyleComponent extends ICmsAbstractButtonComponent {
    @Input()
    iCmsButtonStyle?: TButtonStyles = 'default';

    protected variantInputName = 'iCmsButtonStyle';
}
